import React from "react";
import { StyleSheet, Text, TouchableOpacity } from "react-native";
import { STYLES } from "../assets/styles";
import CustomIcon from "./CustomIcon";

function CustomButton({
  text,
  onPress,
  btnStyle = {},
  textStyle = {},
  upppercase = false,
  leftIcon = {},
  rightIcon = {},
  iconStyle = {},
  transparent,
  disabled,
}) {
  return (
    <TouchableOpacity
      onPress={onPress}
      style={[
        styles.btn,
        {
          backgroundColor: transparent ? "transparent" : STYLES.colors.white,
          opacity: disabled ? 0.5 : 1,
        },
        btnStyle,
      ]}
      disabled={disabled}
    >
      {leftIcon ? (
        <CustomIcon
          type={leftIcon.type}
          name={leftIcon.name}
          style={iconStyle}
        />
      ) : null}
      <Text
        style={[
          styles.text,
          {
            textTransform: upppercase ? "uppercase" : "none",
          },
          textStyle,
        ]}
      >
        {text}
      </Text>
      {rightIcon ? (
        <CustomIcon
          type={rightIcon.type}
          name={rightIcon.name}
          style={iconStyle}
        />
      ) : null}
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  btn: {
    padding: 6,
    backgroundColor: STYLES.colors.white,
    borderRadius: 20,
    margin: 5,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  text: {
    color: STYLES.colors.black,
    margin: 5,
    fontWeight: "bold",
    fontSize: STYLES.fontSizes.small,
  },
});

export default CustomButton;
